module.exports = __webpack_public_path__ + "static/media/IMG_5470.04dc7a31.JPG";